<template>
  <div class="footer">
    <div class="banxin">
      <div class="top">
        <div class="leftBox">
          <p class="title">Shopping Guide</p>
          <!-- <p class="number" style="font-size:28px">services@doravip.net</p>
                <p class="time">09:00-18:00</p>
                <div class="consult">services@doravip.net</div> -->
          <p class="cur-poi" @click="showBox('Shopping Process')">
            Shopping Process
          </p>
          <p class="cur-poi" @click="showBox('Contact us')">Contact us</p>
        </div>
        <div class="centerBox">
          <p class="title">Distribution Mode</p>
          <p class="cur-poi" @click="showBox('Logistics service')">Logistics service</p>
          <p class="cur-poi" @click="showBox('Distribution fee collection standard')">Distribution fee collection standard</p>
        </div>
        <div class="centerBox">
          <p class="title">Payment Method</p>
          <p class="cur-poi" @click="showBox('Online Payment')">Online Payment</p>
          <!-- <div class="qrCode">
                    <p class="title">下载DoraShop</p>
                    <img src="../../../static/image/qrcode.png" alt="">
                </div> -->
        </div>
        <div class="centerBox">
          <p class="title">After-sales Policy</p>
          <p class="cur-poi" @click="showBox('General Principles')">General Principles</p>
          <p class="cur-poi" @click="showBox('Refund instructions')">Refund instructions</p>
          <p class="cur-poi" @click="showBox('Cancel Order')">Cancel Order</p>
        </div>
      </div>
      <p class="bottom" style="color: #d3d3d3;font-size: 14px;">&copy;2021-2022 DoraMall All rights reserved</p>
    </div>
    <el-dialog
      :title="boxTitle"
      :visible.sync="dialogBox"
      width="50%">
        <div class="boxContent" v-if="boxTitle === 'Shopping Process'">
            <p class="boxItem">Ⅰ. Please register for your first purchase</p>
            <p class="boxItem">Ⅱ. Select your favorite products, click directly to buy or add to shopping cart</p>
            <p class="boxItem">Ⅲ. Add or select a receiving address</p>
            <p class="boxItem">Ⅳ. To complete the payment</p>
            <p class="boxItem">Ⅴ. Waiting for the goods</p>
        </div>
        <div class="boxContent" v-if="boxTitle === 'Contact us'">
            <p class="boxItem">E-mail: services@doravip.net</p>
            <p class="boxItem"></p>
        </div>
        <div class="boxContent" v-if="boxTitle === 'Logistics service'">
            <p class="boxItem">Track your order from DoraMall > Login > My order > View logistic info</p>
            <p class="boxItem">Global goods are sent from the warehouse of the international seller by express delivery, which means that the shipping time is relatively long, usually needs 7~20 working days, please wait patiently.</p>
            <p class="boxItem">For more details, please contact: services@doravip.net </p>
        </div>
        <div class="boxContent" v-if="boxTitle === 'Distribution fee collection standard'">
            <p class="boxItem">The freight is usually borne by the international seller. In case of special circumstances, the international seller will contact the user separately</p>
            <p class="boxItem"></p>
            <p class="boxItem"></p>
        </div>
        <div class="boxContent" v-if="boxTitle === 'Online Payment'">
            <p class="boxItem">DoraMall suggest users pay by online payment. It's safer to reduce the offline cash transaction.Paying online is more efficient and allows you to shop for a wide range of products. And if if you don't like the product and would like return, we can deal it more efficiently.</p>
            <p class="boxItem">How to pay online：</p>
            <p class="boxItem">Step 1: Select payment method;</p>
            <p class="boxItem">Step 2: Submit order;</p>
            <p class="boxItem">Step 3: Fill in your credit card information and complete the payment.</p>
            <p class="boxItem">After the payment is successful, the order status becomes paid.</p>
        </div>
        <div class="boxContent" v-if="boxTitle === 'General Principles'">
            <p class="boxItem">Ⅰ. According to the 7-day Return & Exchange principles , DoraMall promises that consumers can apply for Return & Exchange Services for the intact items online within the 7 days of receiving. As for items with quality problems, consumers are accessible to the Return & Exchange Services within the 30 days of receiving; and the exchange goods are available for the 7-day Return & Exchange Services as long as they are intact and confirm with the completeness standards. </p>
            <p class="boxItem">Ⅱ. Consumers requiring the Return & Exchange Services shall submit the after-sale application on DoraMall within the 7 days of receiving. The 7 days are the passed 168 hours calculated from the midnight(0:00) of the next day after the signing for items.</p>
            <p class="boxItem">Ⅲ. Items returned by consumes shall be intact .</p>
            <p class="boxItem">Ⅳ. Consumers shall individually pay the delivery fee of returning goods sent out by DoraMall for free. As for orders sent out by DoraMall with certain delivery cost or for free but under some specific conditions, consumers shall pay all delivery fees by themselves, which caused by the return of part of order or out of conditions.</p>
            <p class="boxItem">Ⅴ. The losses or damages of gifts will not affect the Return & Exchange application; but DoraMall will charge 10% of the order amount as the compensation for the losses or damages. Buyers shall be responsible for related taxation if they lose the invoice.</p>
        </div>
        <div class="boxContent" v-if="boxTitle === 'Refund instructions'">
            <p class="boxItem">1.DoraMall will process your refund application within 3 days.</p>
            <p class="boxItem">2. Once your application is approved, DoraMall will notify you of your return.</p>
            <p class="boxItem">3. Upon receipt of the goods, DoraMall will check the quality of the goods and then decide whether to refund.</p>
            <p class="boxItem">4. If the quality inspection is qualified, the refund can be received within 1-3 working days (except holidays).</p>
            <p class="boxItem">If your return is rejected, DoraMall will contact you and provide you with the reason for the return and the shipment status of the returned item.</p>
        </div>
        <div class="boxContent" v-if="boxTitle === 'Cancel Order'">
            <p class="boxItem">How to cancel an order:</p>
            <p class="boxItem">If the order is not paid, you can cancel the order by following the following steps:</p>
            <p class="boxItem">DoraMall >> Login >> My Order >> Click the relevant Order >> Cancel</p>
            <p class="boxItem"></p>
            <p class="boxItem"></p>
        </div>
      </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      dialogBox: false,
      boxTitle: '',
      boxItems: []
    }
  },
  methods: {
    showBox (title) {
      this.boxTitle = title
      this.dialogBox = true
    },
  },
}
</script>
<style lang = "scss" scoped>
.footer {
  width: 100%;
  height: 384px;
  background-color: #2d2d2d;
  /* opacity: 0.82; */
  color: #ffffff;
  overflow: hidden;
  .banxin {
    width: 1252px;
    height: 100%;
    margin: 0 auto;
    .top {
      margin-top: 100px;
      display: flex;
      margin-bottom: 38px;
      text-align: center;
      .leftBox {
        flex: 1;
        display: flex;
        flex-direction: column;
        .title {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 33px;
        }
        p {
          font-size: 16px;
          line-height: 25px;
          margin-bottom: 10px;
        }
        .number {
          font-size: 40px;
          margin-bottom: 12px;
          font-weight: 500;
        }
        .time {
          font-size: 18px;
          margin-bottom: 33px;
        }
        .consult {
          cursor: pointer;
          margin: 0 auto;
          width: 220px;
          height: 36px;
          line-height: 36px;
          border: 1px solid #ffffff;
          box-sizing: border-box;
          opacity: 0.6;
        }
      }
      .centerBox {
        flex: 1;
        border-left: 2px solid rgba($color: #ffffff, $alpha: 0.15);
        border-right: 2px solid rgba($color: #ffffff, $alpha: 0.15);
        p {
          font-size: 16px;
          line-height: 25px;
          margin-bottom: 10px;
        }
        .title {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 33px;
        }
      }
      .rightBox {
        flex: 1;
        display: flex;
        .aboutUs {
          flex: 1;
          p {
            margin-bottom: 20px;
          }
          .title {
            margin-bottom: 33px;
          }
        }
        .qrCode {
          flex: 1;
          .title {
            margin-bottom: 33px;
          }
          img {
            width: 106px;
            height: 106px;
          }
        }
      }
    }
    .bottom {
      text-align: center;
      font-size: 12px;
      line-height: 24px;
      color: #444444;
    }
  }
}
.boxItem {
  font-size: 14px;
  padding: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/base/footer.vue